import script from "./AiPrompt.vue?vue&type=script&setup=true&lang=ts"
export * from "./AiPrompt.vue?vue&type=script&setup=true&lang=ts"

import "./AiPrompt.vue?vue&type=style&index=0&id=be9766ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be9766ea"]])

export default __exports__